/**
 * Created by Jerker Nord on 2020-03-26.
 */
import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {MonkeysGoldGameAssets} from "../MonkeysGoldGameAssets";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {MonkeysGold} from "../MonkeysGold";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";

export class MonkeysGoldIntroConfig implements GameIntroViewConfig {

    colors: GameIntroColors = {
        slideShowColors: {
            backgroundColor: 0x000000,
            backgroundAlpha: 0.4,
            bulletColor: 0xffffff
        },
        stampColor: 0xFFFFFF,
    };

    stampConfig: StampConfig = {
        xWays: false,
        xNudge: false,
        xPays: true,
        volatility: Volatility.MEDIUM
    };

    background: PIXI.Container;
    borderBottom: PIXI.Container;
    borderTop: PIXI.Container;
    logo: PIXI.Container;
    pages: SlideShowPage[];
    private bgBlack: PIXI.Sprite;

    constructor() {
    }

    public init(): Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add(MonkeysGoldGameAssets.INTRO_BORDER_TILE, MonkeysGoldGameAssets.INTRO_BORDER_TILE);
        imgLoader.add(MonkeysGoldGameAssets.INTRO_BLURRED_BACKGROUND, MonkeysGoldGameAssets.INTRO_BLURRED_BACKGROUND);
        imgLoader.add(MonkeysGoldGameAssets.INTRO_LOGO, MonkeysGoldGameAssets.INTRO_LOGO);
        imgLoader.add(MonkeysGoldGameAssets.INTRO_FEATURE_1, MonkeysGoldGameAssets.INTRO_FEATURE_1);
        imgLoader.add(MonkeysGoldGameAssets.INTRO_FEATURE_2, MonkeysGoldGameAssets.INTRO_FEATURE_2);
        imgLoader.add(MonkeysGoldGameAssets.INTRO_FEATURE_3, MonkeysGoldGameAssets.INTRO_FEATURE_3);
        imgLoader.add(MonkeysGoldGameAssets.INTRO_FEATURE_4, MonkeysGoldGameAssets.INTRO_FEATURE_4);
        imgLoader.add("feature_2_US", "nolimit/screens/images/pageImage_2_US.png");

        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    onResize(): void {
        const bounds = NolimitApplication.screenBounds;
        this.bgBlack.width = bounds.width;
        this.bgBlack.height = bounds.height;
    }


    private initGraphics() {
        this.background = new PIXI.Container();
        this.bgBlack = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.bgBlack.anchor.set(0.5, 0.5);
        this.bgBlack.tint = 0x000000;
        this.background.addChild(this.bgBlack);
        const blurredBackground = new PIXI.Sprite(ImgLoader.getImgTexture(MonkeysGoldGameAssets.INTRO_BLURRED_BACKGROUND));
        blurredBackground.anchor.set(0.5, 0.5);
        blurredBackground.scale.set(2, 2);
        this.background.addChild(blurredBackground);

        this.borderTop = new PIXI.Container();
        const topSprite = new PIXI.Sprite(ImgLoader.getImgTexture(MonkeysGoldGameAssets.INTRO_BORDER_TILE));
        topSprite.anchor.set(0.5, 0.55);
        this.borderTop.addChild(topSprite);
        this.logo = new PIXI.Container();
        const logoSprite = new PIXI.Sprite(ImgLoader.getImgTexture(MonkeysGoldGameAssets.INTRO_LOGO));
        logoSprite.anchor.set(0.5, 0.8);
        this.borderTop.addChild(logoSprite);

        this.borderBottom = new PIXI.Container();
        const bottomSprite = new PIXI.Sprite(ImgLoader.getImgTexture(MonkeysGoldGameAssets.INTRO_BORDER_TILE));
        bottomSprite.rotation = Math.PI;
        bottomSprite.anchor.set(0.5, 0.45);
        this.borderBottom.addChild(bottomSprite);

        const featureText1 = SlotGame.api.translations.translate("Pays out on number of collected symbols.");
        const featureText3 = SlotGame.api.translations.translate("Symbol upgrades whenever a full row is completed.");
        const featureText4 = SlotGame.api.translations.translate("Vine Multiplier that remains throughout the bonus feature.");

        this.pages = [
            new SlideShowPage(ImgLoader.getImgTexture(MonkeysGoldGameAssets.INTRO_FEATURE_1), featureText1),
            new SlideShowPage(ImgLoader.getImgTexture(MonkeysGoldGameAssets.INTRO_FEATURE_3), featureText3),
            new SlideShowPage(ImgLoader.getImgTexture(MonkeysGoldGameAssets.INTRO_FEATURE_4), featureText4)
        ];

        if (MonkeysGold.api.gameClientConfiguration.isSet) {
            if (MonkeysGold.api.gameClientConfiguration.showLowProbabilityGfx || MonkeysGold.api.gameClientConfiguration.jurisdictionName === "US-PA") {
                this.showColossalImagePage();
            }
        } else {
            MonkeysGold.api.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                if (MonkeysGold.api.gameClientConfiguration.showLowProbabilityGfx || MonkeysGold.api.gameClientConfiguration.jurisdictionName === "US-PA") {
                    this.showColossalImagePage();
                }
            });
        }
    }

    private showColossalImagePage(): void {
        const featureText2 = SlotGame.api.translations.translate("Colossal symbols with multiplier up to x500.");
        this.pages.splice(1, 0, new SlideShowPage(ImgLoader.getImgTexture(MonkeysGold.api.gameClientConfiguration.jurisdictionName === "US-PA"?"feature_2_US":MonkeysGoldGameAssets.INTRO_FEATURE_2), featureText2));//#354

    }
}
